<template>
<div class="container">
<mt-header title="用户注册" :fixed="true" >
  <mt-button icon="back" slot="left" @click="doback"></mt-button>
</mt-header>

<div class="form">

<hos @select="sethos"></hos>

<div class="row">
	<div class="col-3 left">姓&nbsp;&nbsp;名</div>
	<div class="col-7">
		<mt-field placeholder="请输入姓名" v-model="f.name"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">身份证</div>
	<div class="col-7">
		<mt-field placeholder="请输入身份证号码" v-model="f.sf"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">性&nbsp;&nbsp;别</div>
	<div class="col-7" style="padding-top:.7rem;">
		<mt-switch v-model="f.sex">{{f.sex?"男":"女"}}</mt-switch>
	</div>
</div>


<div class="row">
	<div class="col-3 left">用户名</div>
	<div class="col-7">
		<mt-field placeholder="请输入用户名" v-model="f.user"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left">密&nbsp;&nbsp;码</div>
	<div class="col-7">
		<mt-field placeholder="请输入密码" v-model="f.psd1" type="password"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left" style="letter-spacing:0;">确认密码</div>
	<div class="col-7">
		<mt-field placeholder="请再次输入密码" v-model="f.psd2" type="password"></mt-field>
	</div>
</div>

<div class="row">	
	<div class="col-3 left nopadding">验证码</div>
	<div class="col-4 nopadding">
		 <mt-field placeholder="请输入验证码" v-model="f.code" @keydown.native.enter="get_telcode" @input="check"></mt-field>
	</div>
	<div class="col-3 nopadding codediv">
		 <img :src="mydata.api+'Code/code/tk/'+f.tk" class="code" alt="验证码" @click="change">
		 <span class="success" v-show="success"><i class="fa fa-check"></i></span>
	</div>
</div>

<div class="row">
	<div class="col-3 left">手机号</div>
	<div class="col-7">
		<mt-field placeholder="请输入手机号码" v-model="f.tel"></mt-field>
	</div>
</div>

<div class="row">	
	<div class="col-3 left" style="letter-spacing:0;">手机验证</div>
	<div class="col-5">
		 <mt-field placeholder="请输入手机验证码" v-model="f.telcode"></mt-field>
	</div>
	<div class="col-2 nopadding">
		<mt-button class="btn" type="primary" @click="get_telcode">获 取</mt-button>
	</div>
</div>

</div>

<div class="row pd">
	<mt-button type="primary" size="large" :disabled="substatus" @click="sub">注 册</mt-button>
</div>


</div>	
</template>

<style scoped>
.container{background: rgb(251,251,251);}	
.pd{padding:.5rem 1rem;}
.btn{border-radius:0;float:right;width:80px;height:52px;}
</style>

<script>
import hos from "../../lib/hos.vue"

export default{
	components:{hos},
	data(){
		return {
			mydata:mydata,
			doback:fun.doback,
			f:{
                name:"",
                sf:"",
                tel:"",
                sex:true,
                user:"",
                psd1:"",
                psd2:"",
                hos:"",
                code:"",
                tk:"",
                telcode:""
              },
			substatus:false,
			success:false,
		}
	},
	created:function(){
		this.init();
	},
	watch:{
		"$route":"init"
	},
	methods:{
		init:function(){
			this.mydata.header=false;
			this.f.tk=+new Date();
		},
		change:function(){
			this.f.tk=+new Date();
			this.success=false;
		},
		check:function(){
           var data={
           	tk:this.f.tk,
           	code:this.f.code,
           }
           var _this=this;
           fun.post(mydata.api+"Code/mycheck",data,function(d){
           	console.log(d)
           	_this.success=d.status==1?true:false;
           },true)
		},
		sethos:function(d){
			this.f.hos=d;
		},
		get_telcode(){
		   var _this=this;
		   fun.post(mydata.api+"Login/reg_get_telcode",this.f,function(d){
			   console.log(d)
			   _this.$toast(d.info);
			   if(d.status==0&&d.info!="验证码错误"){_this.change();}
		   })
		},
		sub(){
			var _this=this;
			this.substatus=true;
			fun.post(mydata.api+"Login/reg",this.f,function(d){
				console.log(d);
				_this.substatus=false;
				if(d.status==1){
					_this.$messagebox.alert("注册成功，请登录").then(function(){
						_this.$router.push("/login");
					})
				}else{
					if(d.info!="验证码错误"){_this.change();}
					_this.$toast(d.info);
				}
			})
		}
	}

}	
</script>


// WEBPACK FOOTER //
// src/components/login/reg.vue